import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Package, Search, FileText, ExternalLink } from "lucide-react";

const ShipmentsTable = ({ shipments = [], loading = false, onTrack }) => {
  if (loading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (!shipments || shipments.length === 0) {
    return (
      <div className="text-center py-12 text-zinc-500">
        <Package className="w-12 h-12 mx-auto mb-4 text-zinc-300" />
        <p>No tienes envíos aún</p>
        <p className="text-sm">Cotiza y genera tu primera guía</p>
      </div>
    );
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      "Guía generada": "bg-blue-100 text-blue-700",
      "En tránsito": "bg-amber-100 text-amber-700",
      "Entregado": "bg-emerald-100 text-emerald-700",
      "Cancelado": "bg-red-100 text-red-700"
    };

    return (
      <Badge className={`${statusMap[status] || "bg-zinc-100 text-zinc-700"}`}>
        {status}
      </Badge>
    );
  };

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Tracking</TableHead>
            <TableHead>Paquetería</TableHead>
            <TableHead>Ruta</TableHead>
            <TableHead>Precio</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead>Fecha</TableHead>
            {onTrack && <TableHead></TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {shipments.map((shipment) => (
            <TableRow key={shipment.shipment_id} data-testid={`shipment-row-${shipment.shipment_id}`}>
              <TableCell className="font-mono text-sm">
                {shipment.tracking_number || "-"}
              </TableCell>
              <TableCell>{shipment.carrier}</TableCell>
              <TableCell className="text-sm">
                {shipment.origin_zip} → {shipment.destination_zip}
              </TableCell>
              <TableCell className="font-medium">
                ${shipment.price?.toFixed(2)}
              </TableCell>
              <TableCell>{getStatusBadge(shipment.status)}</TableCell>
              <TableCell className="text-sm text-zinc-500">
                {formatDate(shipment.created_at)}
              </TableCell>
              {onTrack && (
                <TableCell>
                  <div className="flex items-center gap-2">
                    {shipment.label_url && (
                      <a
                        href={shipment.label_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-emerald-600 hover:text-emerald-800 flex items-center gap-1 text-sm font-medium"
                        data-testid={`download-label-${shipment.shipment_id}`}
                      >
                        <FileText className="w-3.5 h-3.5" /> Guía
                      </a>
                    )}
                    {shipment.tracking_number && shipment.carrier?.toUpperCase().includes("FEDEX") ? (
                      <a
                        href={`https://www.fedex.com/fedextrack/?trknbr=${shipment.tracking_number}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-violet-600 hover:text-violet-800 flex items-center gap-1 text-sm font-medium"
                        data-testid={`track-btn-${shipment.shipment_id}`}
                      >
                        <Search className="w-3.5 h-3.5" /> <ExternalLink className="w-3 h-3" />
                      </a>
                    ) : (
                      <button
                        onClick={() => onTrack(shipment.shipment_id)}
                        className="text-violet-600 hover:text-violet-800 flex items-center gap-1 text-sm font-medium"
                        data-testid={`track-btn-${shipment.shipment_id}`}
                      >
                        <Search className="w-3.5 h-3.5" />
                      </button>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ShipmentsTable;
